// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"e2e6149c","661":"e2e6149c","851":"a3930aa3"}[chunkId] + ".chunk.css";
};